export const isFreeInsurance = (dailyRate?: number): boolean =>
  !dailyRate || dailyRate === 0;

export const getInsuranceDescription = (deductibleAmount: number): string =>
  `${deductibleAmount / 100} €`;

export const getInsuranceShortName = (deductibleAmount: any): string =>
  `SB${deductibleAmount / 100}`;
